import type { MessengerChannel } from '@widgets/messenger/types'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetChannels = () => {
  const { widgetSettings } = useWidgetStore()

  const channelMap = computed(() => {
    return Object.keys(widgetSettings.value.channels).reduce(
      (acc, type) => {
        const channel = widgetSettings.value.channels[type]
        acc[type] = {
          type,
          name: channel.uiSettings.name,
        }
        return acc
      },
      {} as Record<WebWidgetChannelType, MessengerChannel>,
    )
  })

  const activeSortedChannels = computed(() =>
    widgetSettings.value.channelSorting
      .filter((type) => {
        if (type === WebWidgetChannelType.CHAT) {
          const chatChannel = widgetSettings.value.channels[type]
          return !chatChannel.isHidden && chatChannel.isActive
        }

        return widgetSettings.value.channels[type].isActive
      })
      .map((type) => channelMap.value[type]),
  )

  const activeSortedChannelTypes = computed(() => activeSortedChannels.value.map(({ type }) => type))

  return {
    channelMap,
    activeSortedChannels,
    activeSortedChannelTypes,
  }
}
